const CLOUDFRONT_URL_MAPPINGS = {
    'myeduplus-assets.s3.eu-south-1.amazonaws.com': 'prod.files.myedu.it',
    'myeduplus-assets.amazonaws.com': 'prod.files.myedu.it',
    'myedu-assets-dev.s3.eu-south-1.amazonaws.com': 'dev.files.myedu.it',
    'myedu-assets-dev.s3.amazonaws.com': 'dev.files.myedu.it',

    'myeduplus.s3.eu-west-2.amazonaws.com': 'prod.media.myedu.it',
    'myeduplus.s3.amazonaws.com': 'prod.media.myedu.it',
    'myeduplus-school.s3.eu-west-2.amazonaws.com': 'dev.media.myedu.it',
    'myeduplus-school.s3.amazonaws.com': 'dev.media.myedu.it',
    'myeduplus-test.s3.eu-west-2.amazonaws.com': 'test.media.myedu.it',
    'myeduplus-test.s3.amazonaws.com': 'test.media.myedu.it',
};


export function replaceWithCloudFrontUrl(response) {
    const responseJson = JSON.stringify(response);

    const mappedResponseJson = Object.keys(CLOUDFRONT_URL_MAPPINGS).reduce((acc, bucketName) => {
        const cloudFrontUrl = CLOUDFRONT_URL_MAPPINGS[bucketName];

        if (acc.includes(bucketName)) {
            return acc.replaceAll(bucketName, cloudFrontUrl)
        }

        return acc;
    }, responseJson)

    const {
        data,
    } = JSON.parse(mappedResponseJson);

    return new Promise((resolve) => {
        resolve(data)
    })
}